<template>
    <div class="education-courses">
        <CardList
            v-if="!recomended"
            :items="cardListItems"
            :tabType="tabType"
            descriptionType="html"
            finishedBtnText="Обучение завершено"
            continueBtnText="Продолжить обучение"
            lms
        />
        <CardList
            v-else
            :items="recomendedSlicedItems"
            continueBtnText="Начать обучение"
            routerTo="/education/courses/1/"
            :loadMoreTxt="moreBtnTxt"
            descriptionType="html"
            :loadMore="cardListItems.length > 3 && cardListItems.length > recomendedSlicedItems.length"
            @loadMoreCards="loadMoreCards"
        />
    </div>
</template>

<script>
import CardList from '../CardList';
import declinationOfNumber from '../../../../tools/declinationOfNumber';

import { mapGetters } from 'vuex';

const eventsGetters = ['getCoursesCount'];
const getters = ['isMobile'];

export default {
    name: 'EducationCourses',
    props: {
        loading: Boolean,
        items: Array,
        type: String, // contests, events, internship
        emptyText: String,
        tabIndex: Number,
        recomended: Boolean,
    },
    components: {
        CardList,
    },
    data: () => ({
        tabs: [
            {
                label: 'Текущие',
                type: 'active',
            },
            {
                label: 'Завершенные',
                type: 'finished',
            },
        ],
        leftTabsLength: 0,
        currentTab: 0,
        recomendeCardsLength: 3,
        moreBtnTxt: '',
    }),
    methods: {
        goToSite(link) {
            window.open(link, '_blank');
        },
        tabClicked(index) {
            this.currentTab = index;
        },
        loadMoreCards() {
            this.recomendeCardsLength += 3;
            this.currentTabsLength();
        },
        currentTabsLength() {
            this.leftTabsLength = this.leftTabsLength ? this.leftTabsLength - 3 : this.getCoursesCount - 3;
            let decTxt = declinationOfNumber(this.leftTabsLength, 'курс', 'курса', 'курсов');
            this.moreBtnTxt = `Еще ${this.leftTabsLength} ${decTxt}`;
        },
    },
    watch: {
        tabIndex: {
            handler(val) {
                this.tabClicked(val);
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters(getters),
        ...mapGetters('events', eventsGetters),
        tabType() {
            return this.tabs[this.currentTab].type;
        },
        tabItems() {
            return this.items.filter((v) => v.status === this.tabType);
        },
        recomendedSlicedItems() {
            return this.cardListItems.slice(0, this.recomendeCardsLength);
        },
        cardListItems() {
            if (this.recomended) {
                return this.items.map((element) => {
                    return {
                        id: element.foreignCmsId,
                        image: element.cover ? element.cover.url : '',
                        name: element.name,
                        description: element.description,
                    };
                });
            } else {
                return this.tabItems.map((element) => {
                    return {
                        id: element.id,
                        image: element.cover ? element.cover.url : '',
                        name: element.name,
                        description: element.description,
                        lmsLink: element.eventSiteUrl,
                    };
                });
            }
        },
    },
    mounted() {
        this.currentTabsLength();
    },
};
</script>

<style lang="scss" scoped></style>
